function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { ConnectionStatuses } from "../../enum/ConnectionStatuses";
/**
 * 会議素材（データ）　モデル
 */

var UploadDataMaterialsInstanceModel =
/**
 * コンストラクタ
 *
 */
function UploadDataMaterialsInstanceModel() {
  _classCallCheck(this, UploadDataMaterialsInstanceModel);

  this.SessionId = -1;
  this.DataId = -1;
  this.Title = "";
  this.DataUrl = "";
  this.BasicUserName = "";
  this.BasicPassword = "";
  this.Frequency = 60;
  this.Status = ConnectionStatuses.Disconnected;
  this.DataParams = [];
  this.DataItems = [];
};

export { UploadDataMaterialsInstanceModel as default };